import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// components
import List from 'common/List';

const baseString = 'vra-script-product-application-summary__stats';
const ScriptProductApplicationSummaryStats = ({ children }) => {
  const numChildren = children.length;
  const classString = classNames({
    [`${baseString}`]: true,
    [`${baseString}--spread`]: numChildren >= 3,
    [`${baseString}--no-spread`]: numChildren < 3 // with 2 items there is too much space in the component to have space-between for the items
  });

  return (
    <List className={classString} name={`summary-stats`}>
      {children}
    </List>
  );
};
ScriptProductApplicationSummaryStats.propTypes = {
  children: propTypes.any
};
export default ScriptProductApplicationSummaryStats;
